$(document).ready(function(){

  // General Message
  $('.generalmessage').prependTo('header');


  // subpage hero images
  const dynamicPage = $('.dynamicPageContainer');
  if (dynamicPage.length) {
    const firstSection = $('.entityContainerRow.rowIndex-1');
    const firstSectionTitle = firstSection.find('.sectionHeading');
    if (firstSectionTitle.text() === 'hero-image') {
      $('body').addClass('has-subpage-hero');
      const img = firstSection.find('.ImageModule img').attr('data-src');
      const titleModule = firstSection.find('.dynamicPageTitle');
      let heroHTML = '';

      if (titleModule.length > 0) {
        heroHTML = `
          <div class="page-hero-image" style="background-image: url('${img}');">
            <h1>${titleModule.text()}</h1>
          </div>
        `;
      } else {
        heroHTML = `<div class="page-hero-image" style="background-image: url('${img}');"></div>`;
      }


      $(heroHTML).insertAfter('.header');

      firstSection.remove();
    }
  }

  // set header ticket button url
  const tixBtnURL = $('.header .tickets').attr('href');
  $('.custom-buy-tickets-btn').attr('href', tixBtnURL);

  // remove default events link from header nav
  $('.nav .mainNavigationItem5').remove();


});

$(window).load(function() {
    // remove default events link from header nav
    $('.nav .mainNavigationItem5').remove();
});